const Endpoints = {
  login: "auth/login",
  verifyOtp: "auth/verify-otp",
  refreshToken: "auth/refresh-token",
  forgotPwd: "auth/forget-password",
  resetPwd: "auth/reset-password",

  // general
  globalSearch: "search/query",
  removeMedia: "gen/remove-media",
  updateProfile: "gen/update-profile",
  updatePassword: "gen/update-password",
  heatMapData: "gen/heat-map",
  incidentHeatMapData: "gen/incident-heat-map",
  totalIncidentStats: "gen/total-incidents",
  totalPersonStats: "gen/total-persons",
  totalOrgStats: "gen/total-orgs",
  totalWeaponStats: "gen/total-weapons",
  dashboardStats: "gen/dashboard-stats",
  incidentStatsByType: "gen/incident-by-type",
  incidentStatsByTrends: "gen/incident-by-trends",
  weaponUsed: "gen/weapon-used",
  threatLevelByTime: "gen/threat-level-over-time",
  networkGraph: "gen/network-graph",
  orgInvolvementOverRegion: "gen/org-involvement",
  incidentsByPlace: "gen/incidents-on-map",
  threatLevelBarChart: "gen/threat-level-bar-chart",
  groupActivityStats: "gen/group-activity-stats",
  attackMethodStats: "gen/attack-method-stats",
  targetProfileStats: "gen/target-profile-stats",
  countriesThreatIndex: "gen/countries-threat-index",
  quickStats: "gen/quick-stats",
  parseCsv: "gen/parse-csv",

  // notifications
  notiCount: "gen/noti-counter",
  notiList: "gen/notifications-in-dropdown",
  allNotiList: "gen/notifications",
  seeNOtification: "gen/see-noti",
  markAllRead: "gen/mark-all-as-read",
  
  // user management
  getUsers: "user/get-users",
  getUser: "user/get-user",
  userRoles: "user/roles",
  createUser: "user/create-user",
  updateUser: "user/update-user",
  removeUser: "user/remove-user",
  
  // organization management
  orgCreate: "organization/create-organization",
  orgEdit: "organization/update-organization",
  getAllOrgs: "organization/get-organizations",
  getSingleOrg: "organization/view-organization",
  removeOrg: "organization/remove-organization",
  orgIntelProfile: "organization/intel-profile",
  
  //  weapon management
  getWeaponTypes: "weapon/get-weapon-types",
  createWeapon: "weapon/create-weapon",
  updateWeapon: "weapon/update-weapon",
  getSingeWeapon: "weapon/view-weapon",
  getAllWeapons: "weapon/get-weapons",
  removeWeapon: "weapon/remove-weapon",
  
  // address management
  getAllAddress: "organization/get-organizations-with-addresses",
  getSingleAddress: "organization/view-addresses",
  updateOrgAddress: "organization/update-addresses",
  
  // POI (Persons of Interest) — dedicated profiling system
  POI_LIST:   "poi/list",
  POI_VIEW:   "poi/view",
  POI_CREATE: "poi/create",
  POI_UPDATE: "poi/update",
  POI_REMOVE: "poi/remove",

  // POI Evidence — supporting documents, screenshots, links
  POI_EVIDENCE_LIST:   "poi/evidence",
  POI_EVIDENCE_ADD:    "poi/evidence/add",
  POI_EVIDENCE_REMOVE: "poi/evidence/remove",

  // POI Image Gallery
  POI_IMAGES_LIST:   "poi/images",
  POI_IMAGE_ADD:     "poi/images/add",
  POI_IMAGE_REMOVE:  "poi/images/remove",

  // person management (legacy — incident involvement)
  getAllPersons: "person/get-persons",
  findPerson: "person/find-person",
  getPerson: "person/view-person",
  personLevels: "person/get-person-levels",
  addPerson: "person/create-person",
  updatePerson: "person/update-person",
  removePerson: "person/remove-person",
  orgList: "incident/get-organizations",
  allOrgList: "incident/get-all-organizations",
  personList: "incident/persons",
  personRoles: "person/get-person-roles",
  
  // incidents management
  addIncident: "incident/add-incident",
  updateIncident: "incident/update-incident",
  getAllIncident: "incident/list-incidents",
  viewIncident: "incident/view-incident",
  removeIncident: "incident/remove-incident",
  threatNatureList: "incident/threat-nature",
  threatSourcesList: "incident/threat-sources",
  reviewIncident: "incident/review-incident",
  bulkImport: "incident/import-csv",
  geocodingProgress: "incident/geocoding-progress",
  
  // attacks types management
  attackTypesList: "incident/get-attack-types",
  
  // threat levels
  threatLevels: "incident/get-threat-levels",
  
  // Evidence management
  incidentList: "/evidence/incidents-list",
  evidenceCat: "evidence/categories",
  evidenceStatus: "evidence/statuses",
  addEvidence: "evidence/add",
  updateEvidence: "evidence/update",
  viewEvidence: "evidence/view",
  getAllEvidences: "evidence/list",
  removeEvidence: "evidence/remove",

  // support
  generateTicket: "support/generate-ticket",
  getAllTickets: "support/threads",
  sendMessage: "support/send-message",
  getAllMessages: "support/messages",
  updateTicketStatus: "support/update-status",

  // reports
  ORGANIZATION_ACTIVITY_REPORT: "reports/org-activity-report",
  INCIDENT_SUMMARY_REPORT: "reports/incident-summary-report",
  THREAT_LEVEL_DISTRIBUTION_REPORT: "reports/threat-level-distribution-report",
  INVOLVED_PERSONS_REPORT: "reports/involved-persons-report",

  // Intelligence / Predictive Threat Analysis
  INTEL_STATUS:            "intelligence/status",
  INTEL_ANALYSE:           "intelligence/analyse",
  INTEL_THREAT_SCORES:     "intelligence/threat-scores",
  INTEL_HOTSPOTS:          "intelligence/hotspots",
  INTEL_PREDICTIONS:       "intelligence/predictions",
  INTEL_ANOMALIES:         "intelligence/anomalies",
  INTEL_ASSESSMENTS:       "intelligence/assessments",
  INTEL_LATEST_ASSESSMENT: "intelligence/assessments/latest",
  INTEL_ASSESSMENT:        "intelligence/assessments",

  // Live Intelligence Feed — SITREP document processing and DB persistence
  LIVE_INTEL_PARSE:        "live-intel/parse-document",
  LIVE_INTEL_SAVE:         "live-intel/save-items",
  LIVE_INTEL_FEED:         "live-intel/feed",
  LIVE_INTEL_UNREAD_COUNT: "live-intel/unread-count",
  LIVE_INTEL_UPDATE_ITEM:  "live-intel/items",   // PATCH /items/:feedId
  LIVE_INTEL_DELETE_ITEM:  "live-intel/items",   // DELETE /items/:feedId
  LIVE_INTEL_MARK_ALL_READ:"live-intel/mark-all-read",
  LIVE_INTEL_GEO_FEED:    "live-intel/geo-feed",       // GET — plotable items with lat/lng

  // HUMINT Reports — raw field intelligence
  HUMINT_REPORT_SAVE:      "live-intel/humint-report",
  HUMINT_REPORTS_LIST:     "live-intel/humint-reports",
  HUMINT_REPORT_GET:       "live-intel/humint-report",   // GET /humint-report/:id
  HUMINT_REPORT_STATUS:    "live-intel/humint-report",   // PATCH /humint-report/:id/status
  HUMINT_REPORT_DELETE:    "live-intel/humint-report",   // DELETE /humint-report/:id

  // Intelligence Reports — DB-backed uploaded reports
  INTEL_REPORTS_LIST:       "intel-reports/list",
  INTEL_REPORTS_VIEW:       "intel-reports/view",
  INTEL_REPORTS_SAVE:       "intel-reports/save",
  INTEL_REPORTS_DELETE:     "intel-reports",        // DELETE /intel-reports/:reportId
  INTEL_REPORTS_STAR:       "intel-reports",        // PATCH  /intel-reports/:reportId/star
  INTEL_REPORTS_CLEAR_ALL:  "intel-reports/all",

  // Audit Trail — Command Director only
  AUDIT_LOGS:    "audit/logs",
  AUDIT_SUMMARY: "audit/summary",
  AUDIT_EXPORT:  "audit/logs/export",

  // Auth
  LOGOUT: "auth/logout",

  // Public aggregate stats — no auth required (guest dashboard preview)
  PUBLIC_QUICK_STATS:           "public/quick-stats",
  PUBLIC_COUNTRIES_THREAT:      "public/countries-threat-index",
  PUBLIC_GROUP_ACTIVITY:        "public/group-activity",
  PUBLIC_ATTACK_METHODS:        "public/attack-methods",
  PUBLIC_TARGET_PROFILES:       "public/target-profiles",
};

export default Endpoints;
